import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import barcode from './images/usp-barcode.svg'
import diets from './images/usp-diets.svg'
import mealplans from './images/usp-mealplans.svg'
import personalize from './images/usp-personalize.svg'
import recipes from './images/usp-recipes.svg'
import trackers from './images/usp-trackers.svg'

const content = [
  {
    image: diets,
    heading: <FormattedMessage {...messages.whatislifesum_1_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_1_text} />,
  },
  {
    image: mealplans,
    heading: <FormattedMessage {...messages.whatislifesum_2_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_2_text} />,
  },
  {
    image: recipes,
    heading: <FormattedMessage {...messages.whatislifesum_3_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_3_text} />,
  },
  {
    image: barcode,
    heading: <FormattedMessage {...messages.whatislifesum_4_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_4_text} />,
  },
  {
    image: trackers,
    heading: <FormattedMessage {...messages.whatislifesum_5_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_5_text} />,
  },
  {
    image: personalize,
    heading: <FormattedMessage {...messages.whatislifesum_6_heading} />,
    text: <FormattedMessage {...messages.whatislifesum_6_text} />,
  },
]

const USP = ({ image, heading, text }) => {
  return (
    <div className="md:w-1/2 lg:w-1/3 md:px-24 mb-40">
      <img src={image} alt="" className="mt-auto" />
      <h3 className="mt-40 mb-16 text-32 font-bold leading-tighter">
        {heading}
      </h3>
      <p className="mb-16 text-23 leading-normal">{text}</p>
    </div>
  )
}

USP.propTypes = {
  image: PropTypes.string.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
}

function WhatIsLifesum() {
  return (
    <div className="md:flex md:flex-wrap items-stretch text-center">
      {content.map(({ image, heading, text }, i) => {
        return <USP key={i} image={image} heading={heading} text={text} />
      })}
    </div>
  )
}

export default WhatIsLifesum
